import SectionHeading from "@/components/shared/SectionHeading";
import ServiceCard from "@/components/shared/ServiceCard";
import { SERVICES, MARKETING } from "@/data/mockData";

export default function ServicesAndMarketing() {
  return (
    <>
      {/* Consulting Services */}
      <section data-testid="home-services" className="section-pad bg-cream">
        <div className="container-page">
          <SectionHeading
            eyebrow="Consulting Services"
            title={<>Your Growth. <span className="italic text-bronze">My Expertise.</span></>}
            sub="From portfolio planning to disciplined exits — every engagement is built around your goals, timeline and circumstances."
          />
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {SERVICES.map((s, i) => (
              <ServiceCard key={s.title} {...s} idx={i} testIdPrefix="service-card-consulting" />
            ))}
          </div>
        </div>
      </section>

      {/* Marketing */}
      <section data-testid="home-marketing" className="section-pad bg-beige/60">
        <div className="container-page">
          <SectionHeading
            eyebrow="Marketing Solutions"
            title={<>Showcase. Engage. <span className="italic text-bronze">Convert.</span></>}
            sub="High-impact storytelling and precision outreach — the modern way to draw the right buyers to the right home."
          />
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {MARKETING.map((s, i) => (
              <ServiceCard key={s.title} {...s} idx={i} testIdPrefix="service-card-marketing" />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
